import React from 'react';
import PropTypes from 'prop-types';

export const IconProviderOnlyPlayBig = ({ className }) => (
  <svg
    className={className}
    width="141"
    height="29"
    viewBox="0 0 141 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M49.107 13.4538C49.107 8.42998 45.3142 4.90332 40.5233 4.90332C35.7656 4.90332 31.9062 8.42998 31.9062 13.4538C31.9062 18.4776 35.7656 22.0376 40.5233 22.0376C45.281 22.0043 49.107 18.4776 49.107 13.4538ZM36.0651 13.4538C36.0651 10.4927 37.7951 8.59634 40.5233 8.59634C43.1849 8.59634 44.9482 10.4927 44.9482 13.4538C44.9482 16.3816 43.2182 18.3113 40.5233 18.3113C37.7951 18.3113 36.0651 16.3816 36.0651 13.4538Z" fill="url(#onlyplay-linear-0)" />
    <path d="M60.3193 21.8379H64.3783V14.0859C64.3783 10.526 62.3156 8.42993 59.2547 8.42993C57.4581 8.42993 56.0275 9.22842 55.229 10.3263V8.56301H51.1367V21.8379H55.229V14.6182C55.229 12.8216 56.2271 11.8235 57.7908 11.8235C59.3545 11.8235 60.3526 12.8216 60.3526 14.6182V21.8379H60.3193Z" fill="url(#onlyplay-linear-1)" />
    <path d="M66.9731 21.8379H71.0654V4.20459H66.9731V21.8379Z" fill="url(#onlyplay-linear-3)" />
    <path d="M79.9486 16.8806L76.8544 8.56299H72.2964L77.7195 21.4054L74.6586 28.1593H79.0503L87.4012 8.56299H82.9762L79.9486 16.8806Z" fill="url(#onlyplay-linear-4)" />
    <path d="M92.7246 10.4262V8.52976H88.6323V28.1593H92.7246V19.9748C93.4565 21.106 94.8872 22.0375 96.8168 22.0375C100.077 22.0375 102.706 19.3759 102.706 15.1838C102.706 10.9918 100.111 8.3634 96.8168 8.3634C94.8872 8.3634 93.4898 9.2617 92.7246 10.4262ZM98.5802 15.1838C98.5802 17.3131 97.1828 18.4776 95.6524 18.4776C94.1219 18.4776 92.7246 17.3131 92.7246 15.1838C92.7246 13.0545 94.1219 11.8901 95.6524 11.8901C97.1828 11.9233 98.5802 13.0545 98.5802 15.1838Z" fill="url(#onlyplay-linear-5)" />
    <path d="M104.635 21.8379H108.728V4.20459H104.635V21.8379Z" fill="url(#onlyplay-linear-6)" />
    <path d="M110.624 15.1838C110.624 19.3759 113.219 22.0375 116.48 22.0375C118.476 22.0375 119.873 21.1392 120.605 19.9748V21.8712H124.697V8.56303H120.605V10.4594C119.873 9.29497 118.476 8.39667 116.48 8.39667C113.219 8.3634 110.624 10.9918 110.624 15.1838ZM120.605 15.1838C120.605 17.3131 119.241 18.4776 117.677 18.4776C116.147 18.4776 114.75 17.2799 114.75 15.1838C114.75 13.0878 116.147 11.9233 117.677 11.9233C119.241 11.9233 120.605 13.0878 120.605 15.1838Z" fill="url(#onlyplay-linear-7)" />
    <path d="M133.547 16.8806L130.453 8.56299H125.895L131.318 21.4054L128.257 28.1593H132.649L141 8.56299H136.575L133.547 16.8806Z" fill="url(#onlyplay-linear-8)" />
    <path d="M12.4764 25.7638C5.58943 25.7638 0 20.1744 0 13.2874C0 6.40046 5.58943 0.811035 12.4764 0.811035C19.3634 0.811035 24.9528 6.40046 24.9528 13.2874C24.9528 20.1744 19.3634 25.7638 12.4764 25.7638ZM12.4764 4.13808C7.4193 4.13808 3.32704 8.23034 3.32704 13.2874C3.32704 18.3445 7.4193 22.4368 12.4764 22.4368C17.5335 22.4368 21.6258 18.3445 21.6258 13.2874C21.6258 8.23034 17.5335 4.13808 12.4764 4.13808Z" fill="url(#onlyplay-linear-9)" />
    <path d="M12.4762 17.4463C14.773 17.4463 16.635 15.5843 16.635 13.2875C16.635 10.9906 14.773 9.12866 12.4762 9.12866C10.1793 9.12866 8.31738 10.9906 8.31738 13.2875C8.31738 15.5843 10.1793 17.4463 12.4762 17.4463Z" fill="url(#onlyplay-linear-10)" />
    <defs>
      <linearGradient id="onlyplay-linear-0" x1="40.4969" y1="4.88898" x2="40.4969" y2="22.0097" gradientUnits="userSpaceOnUse">
        <stop stopColor="#F79F2D" />
        <stop offset="1" stopColor="#FF4D4D" />
      </linearGradient>
      <linearGradient id="onlyplay-linear-1" x1="57.7601" y1="8.41306" x2="57.7601" y2="21.8429" gradientUnits="userSpaceOnUse">
        <stop stopColor="#F79F2D" />
        <stop offset="1" stopColor="#FF4D4D" />
      </linearGradient>
      <linearGradient id="onlyplay-linear-3" x1="69.0315" y1="4.22219" x2="69.0315" y2="21.8429" gradientUnits="userSpaceOnUse">
        <stop offset="0.2624" stopColor="#F79F2D" />
        <stop offset="1" stopColor="#FF4D4D" />
      </linearGradient>
      <linearGradient id="onlyplay-linear-4" x1="79.8512" y1="8.5559" x2="79.8512" y2="28.153" gradientUnits="userSpaceOnUse">
        <stop stopColor="#F79F2D" />
        <stop offset="0.6512" stopColor="#FF4D4D" />
      </linearGradient>
      <linearGradient id="onlyplay-linear-5" x1="95.6859" y1="8.36547" x2="95.6859" y2="28.1769" gradientUnits="userSpaceOnUse">
        <stop stopColor="#F79F2D" />
        <stop offset="0.6948" stopColor="#FF4D4D" />
      </linearGradient>
      <linearGradient id="onlyplay-linear-6" x1="106.668" y1="4.22219" x2="106.668" y2="21.8429" gradientUnits="userSpaceOnUse">
        <stop offset="0.2427" stopColor="#F79F2D" />
        <stop offset="1" stopColor="#FF4D4D" />
      </linearGradient>
      <linearGradient id="onlyplay-linear-7" x1="117.655" y1="8.36547" x2="117.655" y2="22.0334" gradientUnits="userSpaceOnUse">
        <stop stopColor="#F79F2D" />
        <stop offset="1" stopColor="#FF4D4D" />
      </linearGradient>
      <linearGradient id="onlyplay-linear-8" x1="133.463" y1="8.5559" x2="133.463" y2="28.153" gradientUnits="userSpaceOnUse">
        <stop stopColor="#F79F2D" />
        <stop offset="0.6518" stopColor="#FF4D4D" />
      </linearGradient>
      <linearGradient id="onlyplay-linear-9" x1="12.4747" y1="0.821682" x2="12.4747" y2="25.7747" gradientUnits="userSpaceOnUse">
        <stop stopColor="#F79F2D" />
        <stop offset="1" stopColor="#FF4D4D" />
      </linearGradient>
      <linearGradient id="onlyplay-linear-10" x1="12.4745" y1="9.13938" x2="12.4745" y2="17.457" gradientUnits="userSpaceOnUse">
        <stop stopColor="#F79F2D" />
        <stop offset="1" stopColor="#FF4D4D" />
      </linearGradient>
    </defs>
  </svg>
);

IconProviderOnlyPlayBig.propTypes = {
  className: PropTypes.string,
};

IconProviderOnlyPlayBig.defaultProps = {
  className: '',
};
